import { ReactComponent as LogoIcon } from '../../assets/images/logo.svg'

export interface LogoProps {
  className?: string
}

export const Logo = ({ className }: LogoProps) => {
  return <LogoIcon className={`${className || ''}`} />
}
